import type { GetContractsResponse } from '@vy/api-definition';
import { GetContractsResponseSchema } from '@vy/api-definition';
import { withDefault } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import { queryKeys } from '../../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from '../requests-types/custom-use-query-options';
import { CONTRACTS_PAGE_SIZE } from './use-contracts-consts';

type UseContractsPayload = Parameters<ReturnType<typeof getPrivateApi>['getContracts']>[0];

export function useContracts(
  payload: UseContractsPayload = {},
  options?: CustomUseQueryOptions<GetContractsResponse>,
) {
  return useQuery(
    queryKeys.contracts(...Object.values(payload)),
    async ({ signal }) => {
      const api = getPrivateApi();
      const getContractsResponses = await api.getContracts(
        {
          ...payload,
          pageSize: withDefault(payload.pageSize, CONTRACTS_PAGE_SIZE),
          page: withDefault(payload.page, 0),
        },
        { signal },
      );

      return GetContractsResponseSchema.parse(getContractsResponses);
    },
    {
      keepPreviousData: true,
      ...options,
    },
  );
}
